import React, {useState, useContext, createContext, FC, PropsWithChildren, useEffect} from 'react'
import {LocalizacionModel} from '../../auth'

interface DatosTile {
  nombre: string
  id: string
  descripcion: string
}

interface UserContextTitle {
  data: DatosTile[]
  setData: (data: DatosTile[]) => void
}

interface UserContextTitleDireccion {
  dataDireccion: LocalizacionModel[]
  setDataDireccion: (dataDireccion: LocalizacionModel[]) => void
}

const userContextTitle = createContext<UserContextTitle>({data: [], setData: () => {}})

const userContextTitleDireccion = createContext<UserContextTitleDireccion>({
  dataDireccion: [],
  setDataDireccion: () => {},
})

export function useUserContextTitle() {
  return useContext(userContextTitle)
}

export function useUserContextTitleDireccion() {
  return useContext(userContextTitleDireccion)
}

export const DataContext: FC<PropsWithChildren<{}>> = (props) => {
  const [data, setData] = useState<DatosTile[]>([])

  const [dataDireccion, setDataDireccion] = useState<LocalizacionModel[]>([])

  useEffect(() => {
    const storedData = localStorage.getItem('datosPageTitle')
    if (storedData) {
      const parsedData: DatosTile = JSON.parse(storedData) as DatosTile
      setData([parsedData])
    }

    const storedDataDireccion = localStorage.getItem('dataDirecciones')
    if (storedDataDireccion) {
      const parsedDataDireccion: LocalizacionModel = JSON.parse(
        storedDataDireccion
      ) as LocalizacionModel
      setDataDireccion([parsedDataDireccion])
    }
  }, [])

  return (
    <userContextTitle.Provider value={{data, setData}}>
      <userContextTitleDireccion.Provider value={{dataDireccion, setDataDireccion}}>
        {props.children}
      </userContextTitleDireccion.Provider>
    </userContextTitle.Provider>
  )
}
